// Romaneio manual (PO1-3300, épico PO1-3298): cadastro de romaneio igual ao do
// legado (Frete Lotação → Romaneio). Rotas /romaneios/manual/* do backend_hub
// (instância `api`, que leva o embarcador ativo no header X-Active-Embarcador-Id;
// com "Todos os embarcadores" a API responde 400 "Selecione o embarcador.").
import api from "./api";

const lista = (data) => (Array.isArray(data) ? data : []);

// { total, page, pageSize, itens }. `de`/`ate` (data de embarque) obrigatórios.
export async function listarRomaneios(params = {}) {
  const { data } = await api.get("/romaneios/manual", { params });
  return data || { total: 0, page: 1, pageSize: 0, itens: [] };
}

// Registro + totais + notas vinculadas; 404 quando não existe.
export async function obterRomaneio(id) {
  const { data } = await api.get(`/romaneios/manual/${id}`);
  return data;
}

// 201 com o registro salvo; 400 { campos } / 409 código duplicado.
export async function criarRomaneio(corpo) {
  const { data } = await api.post("/romaneios/manual", corpo);
  return data;
}

// 200 com o registro salvo; 409 na troca de transportadora com notas.
export async function atualizarRomaneio(id, corpo) {
  const { data } = await api.put(`/romaneios/manual/${id}`, corpo);
  return data;
}

// 204; 409 quando uma nota tem documento (CT-e/NFse) ou há histórico.
export async function excluirRomaneio(id) {
  await api.delete(`/romaneios/manual/${id}`);
}

// { total, page, pageSize, itens }. Ao menos um filtro (número, pedido, chave
// ou período de emissão de + até).
export async function listarNotasDisponiveis(id, params = {}) {
  const { data } = await api.get(`/romaneios/manual/${id}/notas-disponiveis`, { params });
  return data || { total: 0, itens: [] };
}

// { vinculadas, ignoradas: [ids] }: as não elegíveis são ignoradas em silêncio.
export async function vincularNotas(id, idsNotas) {
  const { data } = await api.post(`/romaneios/manual/${id}/notas`, { idsNotas });
  return data || { vinculadas: 0, ignoradas: [] };
}

// { desvinculadas }; 409 quando alguma nota tem documento.
export async function desvincularNotas(id, idsNotas) {
  const { data } = await api.delete(`/romaneios/manual/${id}/notas`, { data: { idsNotas } });
  return data || { desvinculadas: 0 };
}

// ─── Listas de apoio ─────────────────────────────────────────────────────────
// [{ id, codigo, nome }] do embarcador ativo × transportadora.
export async function listarRotas(idTransportadora) {
  const { data } = await api.get("/romaneios/manual/rotas", { params: { idTransportadora } });
  return lista(data);
}

// [{ id, cnpj, razaoSocial, fantasia }] do embarcador ativo.
export async function listarTransportadoras() {
  const { data } = await api.get("/romaneios/manual/transportadoras");
  return lista(data);
}

// Cadastro base + os tipos exclusivos do embarcador (PO1-3489).
export async function listarTiposVeiculo(idEmbarcador) {
  const params = Number(idEmbarcador) > 0 ? { idEmbarcador: Number(idEmbarcador) } : undefined;
  const { data } = await api.get("/frete/tipos-veiculo", params ? { params } : undefined);
  return lista(data);
}

export async function listarTiposServico() {
  const { data } = await api.get("/frete/tipos-servico");
  return lista(data);
}

export async function listarModais() {
  const { data } = await api.get("/frete/modais");
  return lista(data);
}

export async function listarEstados() {
  const { data } = await api.get("/frete/estados");
  return lista(data);
}

export async function listarCidades(idEstado) {
  const { data } = await api.get(`/frete/estados/${idEstado}/cidades`);
  return lista(data);
}

export async function listarNegocios(idEmbarcador) {
  const { data } = await api.get(`/embarcadores/${idEmbarcador}/negocios`);
  return lista(data);
}

// Remetentes do embarcador ({ Id, label }: mesma rota dos Parâmetros de
// Remetente), usados em NFse sem notas e Criar fatura.
export async function listarRemetentes(idEmbarcador) {
  const { data } = await api.get("/parametros/resolve/remetentes", { params: { idEmbarcador } });
  return lista(data);
}
